"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Label: {
      fontFamily: theme['$font-default'],
      fontSize: '12px',
      color: theme['$text-color'],
      margin: 0,
      fontWeight: 'normal',
      lineHeight: 'initial',
      boxSizing: 'border-box',
      display: 'inline'
    },
    Disabled: {
      opacity: 0.3
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map